
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAdviceMessageItem as ObcAdviceMessageItemElement} from '@oicl/openbridge-webcomponents/dist/components/advice-message-item/advice-message-item.js';
 
 
 

 
 export const ObcAdviceMessageItem = createComponent({
   react: React,
   tagName: 'obc-advice-message-item',
   elementClass: ObcAdviceMessageItemElement,
   events: {
     
     onMessageClick: 'message-click' as EventName<CustomEvent<void>>,
     onActionClick: 'action-click' as EventName<CustomEvent<void>>,
   }
  });
 
 